(() => {
  if (customElements.get('teabo-hero-video')) return;

  class TeaboHeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.desktop = matchMedia('(min-width: 1000px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.update = this.update.bind(this);
      this.desktop.addEventListener('change', this.update);
      this.reducedMotion.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.update);
      this.reducedMotion?.removeEventListener('change', this.update);
      this.video?.pause();
    }

    update() {
      if (!this.desktop.matches || this.reducedMotion.matches) {
        this.video.pause();
        return;
      }
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.play().catch(() => {});
    }
  }

  customElements.define('teabo-hero-video', TeaboHeroVideo);
})();
